import { TmrBaseResource } from 'stylewhere/api'

export class ProductionOrders extends TmrBaseResource {
  static endpoint = 'api/v1/productionOrders' //tracking
}
